const DEFAULT_TAB_TITLE_LINK_CLASS = 'gl-tab-nav-item';

export { DEFAULT_TAB_TITLE_LINK_CLASS };
